export default "__VITE_ASSET__CdCEFBV2__"